module.exports = __webpack_public_path__ + "static/media/icone_campo_rd.0b37f9f2.svg";